import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import { Autocomplete, TextField } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../reducers'
import {
  fetchCompletedData,
  fetchInboxData,
  getAssignedData,
  getCompleteData,
  getDispatchData,
  getInProgressData,
  getITAdminAssignedData,
  getITAdminCompleteData,
  getITAdminUnassignedData,
  getLabManagerCompleteData,
  getPathologistsList,
  getReadyForPickupData,
  getUnassignedData,
} from '../../../actions'
export default function CustomDatagridDropDownFilter(props: any) {
  const dispatch = useDispatch()
  const { item, applyValue, focusElementRef = null, handleFilter, caseView, sortField } = props
  const assignData = useSelector((state: RootState) => state.inboxData)
  const [selectedValue, setSelectedValue] = useState('')
  const filterTimeout = React.useRef<any>()
  const [filterValueState, setFilterValueState] = React.useState<[string, string]>(item.value ?? '')
  const data = assignData.data
  const [labelName, setLabelName] = useState('')
  const [isUsersFetched, setUsersFetched] = useState(false)
  let assignBy = [] as any
  const { user, role } = useSelector((state: RootState) => state.userLogin)
  const stages =
    role === 'NL_Pathologist'
      ? [
          {
            key: 'AMEND_INITIATED',
            value: 'amend, ready',
          },
          {
            key: 'AMEND_RESULTED_RESULT_RELEASED',
            value: 'amend, report released',
          },
          {
            key: 'CORRECT_ASSIGNED_CONSULT',
            value: 'correction, consult',
          },
          {
            key: 'CORRECT_ASSIGNED_INITIAL',
            value: 'correction, slides pending',
          },
          {
            key: 'CORRECT_ASSIGNED_INPROGRESS',
            value: 'correction, in progress',
          },
          {
            key: 'CORRECT_ASSIGNED_READY',
            value: 'correction, ready',
          },
          {
            key: 'CORRECT_RESULTED_2HRWINDOW',
            value: 'correction, 2Hour wait',
          },
          {
            key: 'CORRECT_RESULTED_RESULT_RELEASED',
            value: 'corrected, report released',
          },
          {
            key: 'PRIMARY_DIAGNOSIS_ASSIGNED_CONSULT',
            value: 'consult',
          },
          {
            key: 'PRIMARY_DIAGNOSIS_ASSIGNED_INITIAL',
            value: 'slides pending',
          },
          {
            key: 'PRIMARY_DIAGNOSIS_ASSIGNED_INPROGRESS',
            value: 'in progress',
          },
          {
            key: 'PRIMARY_DIAGNOSIS_ASSIGNED_READY',
            value: 'pathologist ready',
          },
          {
            key: 'PRIMARY_DIAGNOSIS_NO_SLOTS_INITIAL',
            value: '-',
          },
          {
            key: 'PRIMARY_DIAGNOSIS_RESULTED_2HRWINDOW',
            value: 'resulted, 2Hour wait',
          },
          {
            key: 'PRIMARY_DIAGNOSIS_RESULTED_RESULT_RELEASED',
            value: 'resulted, released',
          },
        ]
      : [
          {
            key: 'AMEND_INITIATED',
            value: 'amend, ready',
          },
          {
            key: 'AMEND_RESULTED_RESULT_RELEASED',
            value: 'amend, report released',
          },
          {
            key: 'CORRECT_ASSIGNED_CONSULT',
            value: 'correction, consult',
          },
          {
            key: 'CORRECT_ASSIGNED_INITIAL',
            value: 'correction',
          },
          {
            key: 'CORRECT_ASSIGNED_INPROGRESS',
            value: 'correction, in progress',
          },
          {
            key: 'CORRECT_ASSIGNED_READY',
            value: 'correction, ready',
          },
          {
            key: 'CORRECT_RESULTED_2HRWINDOW',
            value: 'correction, 2Hour wait',
          },
          {
            key: 'CORRECT_RESULTED_RESULT_RELEASED',
            value: 'corrected, report released',
          },
          {
            key: 'PRIMARY_DIAGNOSIS_ASSIGNED_CONSULT',
            value: 'consult',
          },
          {
            key: 'PRIMARY_DIAGNOSIS_ASSIGNED_INITIAL',
            value: 'assigned',
          },
          {
            key: 'PRIMARY_DIAGNOSIS_ASSIGNED_INPROGRESS',
            value: 'in progress',
          },
          {
            key: 'PRIMARY_DIAGNOSIS_ASSIGNED_READY',
            value: 'pathologist ready',
          },
          {
            key: 'PRIMARY_DIAGNOSIS_NO_SLOTS_INITIAL',
            value: 'no slots',
          },
          {
            key: 'PRIMARY_DIAGNOSIS_RESULTED_2HRWINDOW',
            value: 'resulted, 2Hour wait',
          },
          {
            key: 'PRIMARY_DIAGNOSIS_RESULTED_RESULT_RELEASED',
            value: 'resulted, released',
          },
        ]
  const { procedure_codes, states } = useSelector((state: RootState) => state.appConfig)

  const getUsers = useSelector((state: RootState) => state.addPathologistsList)
  const pathologists = getUsers?.data
  let activeUsers = [] as any
  let activePathologistUsers = [] as any
  if (pathologists) {
    const a = pathologists.filter((user) => {
      return user.user_roles == 'NL_Pathologist' && user.user_status === true
    })
    activePathologistUsers = a.map((user) => {
      return { user_name: `${user.first_name}, ${user.last_name}`, user_id: Number(`${user.user_id}`) }
    })
    activePathologistUsers.push({ user_name: 'From Lab', user_id: 0 })
  }
  if (pathologists) {
    const filterUserResults = pathologists.filter((value) => {
      return value.user_status === true
    })
    activeUsers = filterUserResults.map((user) => {
      return { user_name: `${user.first_name}, ${user.last_name}`, user_id: Number(`${user.user_id}`) }
    })
    activeUsers.push({ user_name: 'From Lab', user_id: 0 })
  }
  const procedureCodeList = procedure_codes.map((pCode: any) => {
    return pCode.cdx_procedure_code + ' - ' + pCode.description
  })

  useEffect(() => {
    if (props && props.item && props.item.columnField === 'stat_flag') {
      setLabelName('Select priority')
    } else if (props.item.columnField === 'created_by' || props.item.columnField === 'first_name') {
      setLabelName('Select users')
    } else if (props.item.columnField === 'workflow_stage_id') {
      setLabelName('Select case status')
    } else if (props.item.columnField === 'procedure_code') {
      setLabelName('Select case type')
    } else if (props.item.columnField === 'outcome') {
      setLabelName('Select result')
    } else if (props.item.columnField === 'state') {
      setLabelName('Select location')
    } else if (props.item.columnField === 'first_name') {
      setLabelName('Select Received User ')
    }
  }, [props, labelName])

  useEffect(() => {
    if (
      isUsersFetched === false &&
      props &&
      props.item &&
      (props.item.columnField === 'created_by' || props.item.columnField === 'first_name')
    ) {
      dispatch(
        getPathologistsList({
          id: user,
          caseId: data.caseId,
        }),
      )
      setUsersFetched(true)
    }
  }, [props, isUsersFetched])

  const getColumnType = (columnName: string) => {
    return data.map((caseItem: any) => {
      if (columnName === 'stat_flag') {
        return caseItem.stat_flag ? 'High' : 'Standard'
      } else {
        return caseItem[columnName] ? caseItem[columnName] : 'undefined'
      }
    })
  }

  if (props.item.columnField === 'procedure_code') {
    assignBy = procedureCodeList
  } else if (props.item.columnField === 'created_by' && getUsers.data) {
    assignBy = activeUsers.map((pathName: any) => {
      return pathName.user_name
    })
  } else if (props.item.columnField === 'stat_flag') {
    assignBy = ['Standard', 'High']
  } else if (props.item.columnField === 'outcome') {
    assignBy = ['NORMAL', 'undefined']
  } else if (props.item.columnField === 'state') {
    assignBy = states.map((state: any) => {
      return state.state_code
    })
  } else if (props.item.columnField === 'first_name' && getUsers.data) {
    assignBy = activePathologistUsers.map((pathName: any) => {
      return pathName.user_name
    })
  } else if (props.item.columnField === 'workflow_stage_id') {
    assignBy = stages.map((stage: any) => {
      return stage.value
    })
  }

  const uniqueAssignBy = assignBy.filter(function (v, i, self) {
    return i == self.indexOf(v)
  })
  const sortedAssignBy = uniqueAssignBy.sort()
  const [applying, setIsApplying] = React.useState(false)
  React.useEffect(() => {
    return () => {
      clearTimeout(filterTimeout.current)
    }
  }, [])

  React.useEffect(() => {
    const itemValue = item.value ?? [undefined, undefined]
    setFilterValueState(itemValue)
  }, [item.value])

  let assignedIndex = [] as any

  const handleSelect = async (event, value) => {
    value ? setSelectedValue(value) : setSelectedValue('')
    let filterValue = ''
    let statFlag = 0
    applyValue({ ...item, value: [value] })

    if (props.item.columnField === 'workflow_stage_id') {
      assignedIndex = stages.findIndex((col) => col.value === value)
      filterValue = assignedIndex !== -1 ? stages[assignedIndex].key : ''
    } else if (props.item.columnField === 'created_by' || props.item.columnField === 'first_name') {
      const b = activeUsers.filter((pathologist) => {
        return pathologist.user_name === value
      })
      filterValue = b.length > 0 ? b[0].user_id : ''
    } else if (props.item.columnField === 'stat_flag') {
      statFlag = value === 'Standard' ? 0 : 1
    } else if (props.item.columnField === 'procedure_code') {
      const proc_code = value ? value.split(' - ')[0] : ''
      const abc = procedure_codes.filter((pCode: any) => {
        return pCode.cdx_procedure_code === proc_code
      })
      filterValue = abc.length ? abc[0].cdx_procedure_code : ''
    } else if (props.item.columnField === 'state') {
      const c = states.filter((state) => {
        return state.state_code === value
      })
      filterValue = c.length > 0 ? c[0].state_code : ''
    } else {
      filterValue = value ? value : ''
    }

    if (caseView === 'ready_for_pickup' && (role === 'NL_SpecimenLogistics' || role === 'NL_WOMA_ADMIN')) {
      if (value) {
        await dispatch(
          getReadyForPickupData({
            id: user,
            caseView: caseView,
            filterField: props.item.columnField,
            filterValue: props.item.columnField === 'stat_flag' ? statFlag : filterValue,
            startDate: null,
            endDate: null,
            sortOrder: 'asc',
            pageIndex: 0,
            pageSize: 10,
            sortField: sortField,
          }),
        )
      } else {
        await dispatch(
          getReadyForPickupData({
            id: user,
            caseView: caseView,
            filterField: sortField,
            filterValue: null,
            startDate: null,
            endDate: null,
            sortOrder: 'asc',
            pageIndex: 0,
            pageSize: 10,
            sortField: sortField,
          }),
        )
      }
    } else if (caseView === 'dispatch' && (role === 'NL_SpecimenLogistics' || role === 'NL_WOMA_ADMIN')) {
      if (value) {
        await dispatch(
          getDispatchData({
            id: user,
            caseView: caseView,
            filterField: props.item.columnField === 'first_name' ? 'user_id' : props.item.columnField,
            filterValue: props.item.columnField === 'stat_flag' ? statFlag : filterValue,
            startDate: null,
            endDate: null,
            sortOrder: 'asc',
            pageIndex: 0,
            pageSize: 10,
            sortField: sortField,
          }),
        )
      } else {
        await dispatch(
          getDispatchData({
            id: user,
            caseView: caseView,
            filterField: sortField,
            filterValue: null,
            startDate: null,
            endDate: null,
            sortOrder: 'asc',
            pageIndex: 0,
            pageSize: 10,
            sortField: sortField,
          }),
        )
      }
    } else if (caseView === 'in_progress' && role === 'NL_SpecimenLogistics') {
      if (value) {
        await dispatch(
          getInProgressData({
            id: user,
            caseView: caseView,
            filterField: props.item.columnField,
            filterValue: props.item.columnField === 'stat_flag' ? statFlag : filterValue,
            startDate: null,
            endDate: null,
            sortOrder: 'asc',
            pageIndex: 0,
            pageSize: 10,
            sortField: sortField,
          }),
        )
      } else {
        await dispatch(
          getInProgressData({
            id: user,
            caseView: caseView,
            filterField: sortField,
            filterValue: null,
            startDate: null,
            endDate: null,
            sortOrder: 'asc',
            pageIndex: 0,
            pageSize: 10,
            sortField: sortField,
          }),
        )
      }
    } else if (caseView === 'completed' && role === 'NL_SpecimenLogistics') {
      if (value) {
        await dispatch(
          getCompleteData({
            id: user,
            caseView: caseView,
            filterField: props.item.columnField,
            filterValue: props.item.columnField === 'stat_flag' ? statFlag : filterValue,
            startDate: null,
            endDate: null,
            sortOrder: 'desc',
            pageIndex: 0,
            pageSize: 10,
            sortField: sortField,
          }),
        )
      } else {
        await dispatch(
          getCompleteData({
            id: user,
            caseView: caseView,
            filterField: 'updated_datetime',
            filterValue: null,
            startDate: null,
            endDate: null,
            sortOrder: 'desc',
            pageIndex: 0,
            pageSize: 10,
            sortField: sortField,
          }),
        )
      }
    } else if (caseView === 'assigned' && role === 'NL_Pathologist') {
      if (value) {
        await dispatch(
          fetchInboxData({
            id: user,
            caseView: caseView,
            filterField: props.item.columnField,
            filterValue: props.item.columnField === 'stat_flag' ? statFlag : filterValue,
            startDate: null,
            endDate: null,
            sortOrder: 'asc',
            sortField: sortField,
            pageIndex: 0,
            pageSize: 10,
          }),
        )
      } else {
        await dispatch(
          fetchInboxData({
            id: user,
            caseView: caseView,
            filterField: sortField,
            filterValue: null,
            startDate: null,
            endDate: null,
            sortOrder: 'asc',
            sortField: sortField,
            pageIndex: 0,
            pageSize: 10,
          }),
        )
      }
    } else if (caseView === 'completed' && role === 'NL_Pathologist') {
      if (value) {
        await dispatch(
          fetchCompletedData({
            id: user,
            caseView: caseView,
            filterField: props.item.columnField,
            filterValue: props.item.columnField === 'stat_flag' ? statFlag : filterValue,
            startDate: null,
            endDate: null,
            sortOrder: 'desc',
            pageIndex: 0,
            pageSize: 10,
            sortField: sortField,
          }),
        )
      } else {
        await dispatch(
          fetchCompletedData({
            id: user,
            caseView: caseView,
            filterField: 'updated_datetime',
            filterValue: null,
            startDate: null,
            endDate: null,
            sortOrder: 'desc',
            sortField: sortField,
            pageIndex: 0,
            pageSize: 10,
          }),
        )
      }
    } else if (caseView === 'unassigned' && role === 'NL_LabManager') {
      if (value) {
        await dispatch(
          getUnassignedData({
            id: user,
            caseView: caseView,
            filterField: props.item.columnField,
            filterValue: props.item.columnField === 'stat_flag' ? statFlag : filterValue,
            startDate: null,
            endDate: null,
            sortOrder: 'asc',
            sortField: sortField,
            pageIndex: 0,
            pageSize: 10,
          }),
        )
      } else {
        await dispatch(
          getUnassignedData({
            id: user,
            caseView: caseView,
            filterField: sortField,
            filterValue: null,
            startDate: null,
            endDate: null,
            sortOrder: 'asc',
            sortField: sortField,
            pageIndex: 0,
            pageSize: 10,
          }),
        )
      }
    } else if (caseView === 'assigned' && role === 'NL_LabManager') {
      if (value) {
        await dispatch(
          getAssignedData({
            id: user,
            caseView: caseView,
            filterField: props.item.columnField,
            filterValue: props.item.columnField === 'stat_flag' ? statFlag : filterValue,
            startDate: null,
            endDate: null,
            sortOrder: 'asc',
            sortField: sortField,
            pageIndex: 0,
            pageSize: 10,
          }),
        )
      } else {
        await dispatch(
          getAssignedData({
            id: user,
            caseView: caseView,
            filterField: sortField,
            filterValue: null,
            startDate: null,
            endDate: null,
            sortOrder: 'asc',
            sortField: sortField,
            pageIndex: 0,
            pageSize: 10,
          }),
        )
      }
    } else if (caseView === 'completed' && role === 'NL_LabManager') {
      if (value) {
        await dispatch(
          getLabManagerCompleteData({
            id: user,
            caseView: caseView,
            filterField: props.item.columnField,
            filterValue: props.item.columnField === 'stat_flag' ? statFlag : filterValue,
            startDate: null,
            endDate: null,
            sortOrder: 'desc',
            sortField: sortField,
            pageIndex: 0,
            pageSize: 10,
          }),
        )
      } else {
        await dispatch(
          getLabManagerCompleteData({
            id: user,
            caseView: caseView,
            filterField: 'updated_datetime',
            filterValue: null,
            startDate: null,
            endDate: null,
            sortOrder: 'desc',
            sortField: sortField,
            pageIndex: 0,
            pageSize: 10,
          }),
        )
      }
    } else if (caseView === 'unassigned' && role === 'NL_WOMA_ADMIN') {
      if (value) {
        await dispatch(
          getITAdminUnassignedData({
            id: user,
            caseView: caseView,
            filterField: props.item.columnField,
            filterValue: props.item.columnField === 'stat_flag' ? statFlag : filterValue,
            startDate: null,
            endDate: null,
            sortOrder: 'asc',
            sortField: sortField,
            pageIndex: 0,
            pageSize: 10,
          }),
        )
      } else {
        await dispatch(
          getITAdminUnassignedData({
            id: user,
            caseView: caseView,
            filterField: sortField,
            filterValue: null,
            startDate: null,
            endDate: null,
            sortOrder: 'asc',
            sortField: sortField,
            pageIndex: 0,
            pageSize: 10,
          }),
        )
      }
    } else if (caseView === 'assigned' && role === 'NL_WOMA_ADMIN') {
      if (value) {
        await dispatch(
          getITAdminAssignedData({
            id: user,
            caseView: caseView,
            filterField: props.item.columnField,
            filterValue: props.item.columnField === 'stat_flag' ? statFlag : filterValue,
            startDate: null,
            endDate: null,
            sortOrder: 'asc',
            sortField: sortField,
            pageIndex: 0,
            pageSize: 10,
          }),
        )
      } else {
        await dispatch(
          getITAdminAssignedData({
            id: user,
            caseView: caseView,
            filterField: sortField,
            filterValue: null,
            startDate: null,
            endDate: null,
            sortOrder: 'asc',
            sortField: sortField,
            pageIndex: 0,
            pageSize: 10,
          }),
        )
      }
    } else if (caseView === 'completed' && role === 'NL_WOMA_ADMIN') {
      if (value) {
        await dispatch(
          getITAdminCompleteData({
            id: user,
            caseView: caseView,
            filterField: props.item.columnField,
            filterValue: props.item.columnField === 'stat_flag' ? statFlag : filterValue,
            startDate: null,
            endDate: null,
            sortOrder: 'desc',
            sortField: sortField,
            pageIndex: 0,
            pageSize: 10,
          }),
        )
      } else {
        await dispatch(
          getITAdminCompleteData({
            id: user,
            caseView: caseView,
            filterField: 'updated_datetime',
            filterValue: null,
            startDate: null,
            endDate: null,
            sortOrder: 'desc',
            sortField: sortField,
            pageIndex: 0,
            pageSize: 10,
          }),
        )
      }
    }
    handleFilter({
      filterField: props.item.columnField,
      filterValue: props.item.columnField === 'stat_flag' ? statFlag : filterValue,
      startDate: null,
      endDate: null,
    })
  }

  return (
    <Box
      sx={{
        alignItems: 'end',
      }}
    >
      <Autocomplete
        disablePortal
        value={selectedValue}
        options={sortedAssignBy}
        id="combo-box-demo"
        onChange={(event, value) => handleSelect(event, value)}
        style={{ width: '320px', backgroundColor: 'white' }}
        renderInput={(params) => (
          <TextField {...params} label={labelName} variant="outlined" size="small" style={{ width: '320px' }} />
        )}
      />
    </Box>
  )
}
